import React from "react";
import styled from "styled-components";
import { useHoverEffect } from "./useHoverEffect";

import {
  baseLight,
  baseLighter,
  hover,
  hoverAlt,
  content,
  // contentDark,
} from "./styles/colors";

import image1 from "../images/noise.png";

const CardContainer = styled.div`
  --border-angle: ${(props) => props.angle};
  --finish-angle: ${(props) => props.finishAngle};
  width: 150px;
  height: 150px;
  // background-color: ${baseLighter};
  background: conic-gradient(from var(--border-angle), transparent 80%, #D8CFF3, #5230b8), linear-gradient(to left top, #0E0620 0%, #3A18A5 60%, #8A5DD9 90%);
  border-radius: ${(props) => props.borderRadius};
  position: relative;
  overflow: hidden;

  animation: bg-spin 4s linear infinite;
  @keyframes bg-spin {
    to {
      --border-angle: var(--finish-angle);
    }
  }
  @property --border-angle {
    syntax: "<angle>";
    inherits: true;
    initial-value: ${(props) => props.angle};
  }

  &:hover::before {
    opacity: 1;
  }

  &::before,
  &::after {
    border-radius: inherit;
    content: "";
    height: 100%;
    left: 0px;
    opacity: 0;
    position: absolute; // results in a z-stacking before&after
    top: 0px;
    transition: opacity 300ms;
    width: 100%;
  }

  // this is the background glow effect, will be triggered only by the hover effect on the card element

  &::before {
    background: radial-gradient(
      500px circle at var(--mouse-x) var(--mouse-y),
      ${hoverAlt},
      transparent 40%
    );
    z-index: 3;
  }

  // this is the border glow effect, will be triggered by the hover effect on the parent element

  &::after {
    background: radial-gradient(
      400px circle at var(--mouse-x) var(--mouse-y),
      ${hover},
      transparent 40%
    );
    z-index: 1;
  }
`;

const CardGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 149px);
  grid-template-rows: repeat(3, 149px);
  max-width: 500px;
  align-items: center;
  justify-content: center;

  &:hover > ${CardContainer}::after {
    opacity: 1; // trigger border glow effect
  }
`;

const CardContent = styled.div`
  background-color: ${baseLight};
  color: ${content};
  inset: 1px;
  border-radius: ${(props) => props.borderRadius2};
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  gap: 8px;
  position: absolute;
  z-index: 2;
  pointer-events: none;
`;

const CardImage = styled.div``;

// const CardTitleGroup = styled.div`
//   display: flex;
//   flex-direction: row;
//   gap: 8px;
//   padding: 12px;
// `;

// const CardTitle = styled.h3`
//   color: ${content};

//   font-size: 12px;
//   font-weight: 400;
//   margin: 0px;
// `;

// const CardText = styled.p`
//   color: ${contentDark};
//   font-size: 10px;
//   line-height: 1.3;
//   font-weight: 300;
//   margin: 0px;
// `;

const CardGroup = () => {
  const hoverContainerRef = useHoverEffect();

  return (
    <CardGrid ref={hoverContainerRef} style={{ opacity: "0.8" }}>
      <Card
        borderRadius={"75px 0 0 75px"}
        borderRadius2={"74px 0 0 74px"}
        angle={"90deg"}
        finishAngle={"450deg"}
        image={image1}
        // title={"Plan"}
        // text={"Create new tasks and subtasks in seconds"}
      />
      <Card
        borderRadius={"0 75px 75px 0"}
        borderRadius2={"0 74px 74px 0"}
        angle={"0deg"}
        finishAngle={"360deg"}
        image={image1}
        // title={"Priority"}
        // text={"Synchronized instantly across all users"}
      />
      <Card
        borderRadius={"75px 0 0 75px"}
        borderRadius2={"74px 0 0 74px"}
        angle={"360deg"}
        finishAngle={"0deg"}
        image={image1}
        // title={"Relax"}
        // text={"Don’t sprint - build momentum with Cycles"}
      />
      <Card
        borderRadius={"75px"}
        borderRadius2={"74px"}
        image={image1}
        angle={"180deg"}
        finishAngle={"540deg"}
        // title={"Plan"}
        // text={"Create new tasks and subtasks in seconds"}
      />
      <Card
        borderRadius={"75px 0 75px 75px"}
        borderRadius2={"74px 0 74px 74px"}
        image={image1}
        angle={"-90deg"}
        finishAngle={"270deg"}
        // title={"Priority"}
        // text={"Synchronized instantly across all users"}
      />
      {/* <Card
        // image={image3}
        // title={"Relax"}
        // text={"Don’t sprint - build momentum with Cycles"}
      /> */}
    </CardGrid>
  );
};

const Card = (props) => {
  return (
    <CardContainer borderRadius={props.borderRadius} angle={props.angle} finishAngle={props.finishAngle}>
      <CardContent borderRadius2={props.borderRadius2}>
        <CardImage>
          <img
            src={props.image}
            alt=""
            style={{ width: "100%", display: "flex" }}
          ></img>
        </CardImage>
        {/* <CardTitleGroup>
          <CardTitle>{props.title}</CardTitle>
          <CardText>{props.text}</CardText>
        </CardTitleGroup> */}
      </CardContent>
    </CardContainer>
  );
};

export default CardGroup;
